/**
 * Fly-to-Cart Animation für Rimaal.de (Impulse-Theme)
 * -----------------------------------------------------
 * Animiert beim Klick auf "In den Warenkorb" (Produktseite: [data-add-to-cart]
 * in snippets/product-form.liquid, Kollektions-/Grid-Seiten: [data-quick-add]
 * in snippets/product-grid-item.liquid) ein Klon-Bild vom Produktbild zum
 * Warenkorb-Icon im Header (#HeaderCartIcon) und lässt das Icon dort kurz
 * "bouncen".
 *
 * Rein kosmetisch / non-blocking: läuft komplett unabhängig von den
 * bestehenden Add-to-Cart-Handlern (Theme-Cart-Drawer, Quick-Add-Script)
 * und greift nicht in deren Logik oder die Netzwerk-Requests ein. Der
 * Klick-Listener läuft in der Capture-Phase, damit die Animation auch dann
 * startet, wenn ein anderer Handler den Button im selben Klick sofort
 * deaktiviert (z. B. das bestehende Quick-Add-Script).
 */
(function () {
  'use strict';

  var CART_ICON_SELECTOR = '#HeaderCartIcon';
  var TRIGGER_SELECTOR = '[data-add-to-cart], [data-quick-add]';
  var DURATION = 600;

  function FlyToCartAnimation(options) {
    options = options || {};
    this.cartIconSelector = options.cartIconSelector || CART_ICON_SELECTOR;
    this.duration = options.duration || DURATION;
    this.easing = options.easing || 'cubic-bezier(0.55, 0, 1, 0.45)';
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  FlyToCartAnimation.prototype.getCartIcon = function () {
    var icon = document.querySelector(this.cartIconSelector);
    if (!icon) {
      console.warn('[FlyToCartAnimation] Cart-Icon "' + this.cartIconSelector + '" nicht gefunden.');
    }
    return icon;
  };

  FlyToCartAnimation.prototype.fly = function (sourceEl) {
    var cartIcon = this.getCartIcon();
    if (!sourceEl || !cartIcon) return;

    if (this.reducedMotion) {
      this.bounceCartIcon(cartIcon);
      return;
    }

    var src = sourceEl.currentSrc || sourceEl.src;
    if (!src) {
      this.bounceCartIcon(cartIcon);
      return;
    }

    var startRect = sourceEl.getBoundingClientRect();
    var endRect = cartIcon.getBoundingClientRect();

    // Bild aktuell nicht sichtbar/gerendert (z. B. 0x0) -> nur Bounce als Feedback
    if (startRect.width === 0 || startRect.height === 0) {
      this.bounceCartIcon(cartIcon);
      return;
    }

    var clone = document.createElement('img');
    clone.src = src;
    clone.alt = '';
    clone.className = 'fly-to-cart-clone';
    clone.style.width = startRect.width + 'px';
    clone.style.height = startRect.height + 'px';
    clone.style.top = startRect.top + 'px';
    clone.style.left = startRect.left + 'px';
    document.body.appendChild(clone);

    var deltaX = endRect.left + endRect.width / 2 - (startRect.left + startRect.width / 2);
    var deltaY = endRect.top + endRect.height / 2 - (startRect.top + startRect.height / 2);
    var targetSize = Math.min(endRect.width, endRect.height) * 0.5;
    var endScale = Math.max(0.05, targetSize / Math.max(startRect.width, startRect.height));

    var keyframes = [
      { transform: 'translate(0, 0) scale(1)', opacity: 1, offset: 0 },
      {
        transform:
          'translate(' + deltaX * 0.5 + 'px, ' + (deltaY * 0.5 - 60) + 'px) scale(' + (1 + endScale) / 2 + ')',
        opacity: 1,
        offset: 0.5,
      },
      {
        transform: 'translate(' + deltaX + 'px, ' + deltaY + 'px) scale(' + endScale + ')',
        opacity: 0,
        offset: 1,
      },
    ];

    var animation = clone.animate(keyframes, {
      duration: this.duration,
      easing: this.easing,
      fill: 'forwards',
    });

    var self = this;
    var cleanup = function () {
      if (clone.parentNode) clone.parentNode.removeChild(clone);
      self.bounceCartIcon(cartIcon);
    };
    animation.onfinish = cleanup;
    animation.oncancel = cleanup;
    // Absicherung, falls onfinish aus irgendeinem Grund nicht feuert
    setTimeout(function () {
      if (document.body.contains(clone)) cleanup();
    }, self.duration + 300);
  };

  FlyToCartAnimation.prototype.bounceCartIcon = function (cartIcon) {
    if (!cartIcon || this.reducedMotion) return;
    cartIcon.classList.remove('cart-icon-bounce');
    void cartIcon.offsetWidth; // Reflow erzwingen, damit die Animation neu startet
    cartIcon.classList.add('cart-icon-bounce');
    cartIcon.addEventListener('animationend', function handler() {
      cartIcon.classList.remove('cart-icon-bounce');
      cartIcon.removeEventListener('animationend', handler);
    });
  };

  /**
   * Ermittelt das passende Produktbild für den Flug:
   * - Auf Kollektions-/Grid-Seiten: das Bild der Produktkarte (.grid-product),
   *   die den geklickten Button enthält.
   * - Auf der Produktdetailseite: das aktuell aktive bzw. erste Slideshow-Bild.
   */
  function findProductImage(button) {
    var card = button.closest('.grid-product');
    if (card) {
      var gridImg = card.querySelector('img.image-element, img.grid-product__image');
      if (gridImg) return gridImg;
    }

    var photos = document.querySelector('[data-product-photos]');
    if (photos) {
      var activeImg =
        photos.querySelector('.is-selected img.image-element, .is-active img.image-element') ||
        photos.querySelector('img.image-element');
      if (activeImg) return activeImg;
    }

    return null;
  }

  document.addEventListener('DOMContentLoaded', function () {
    window.flyToCartAnimation = window.flyToCartAnimation || new FlyToCartAnimation();

    // Capture-Phase: läuft vor dem bestehenden Quick-Add-Handler (der den
    // Button im selben Klick disabled), damit wir den echten Ausgangszustand sehen.
    document.addEventListener(
      'click',
      function (event) {
        var button = event.target.closest(TRIGGER_SELECTOR);
        if (!button || button.disabled) return;

        var img = findProductImage(button);
        if (img) {
          window.flyToCartAnimation.fly(img);
        } else {
          window.flyToCartAnimation.bounceCartIcon(window.flyToCartAnimation.getCartIcon());
        }
      },
      true
    );
  });

  window.FlyToCartAnimation = FlyToCartAnimation;
})();
